import { defineStore } from 'pinia'

export const useMyDataStore = defineStore('myData', {
  state: (): any => {
    return {
      breadcrumbsTool: [], // 工具数据-面包屑列表
      breadcrumbsProject: [], // 项目数据-面包屑列表
    }
  },
  actions: {
    setBreadcrumbs(stateData: any, flag: string) { 
      if (flag === 'project-data') {
        this.breadcrumbsProject = stateData
      } else if (flag === 'tool-data') { 
        this.breadcrumbsTool =  stateData 
      }
    },
  }
})
